import React, { useContext } from 'react';
import MediaElement from '../MediaElement.jsx';
import StateContext from '../../contexts/StateContext';
import CameraOffIcon from '../../../images/icons/camera-off.svg';
import MicrophoneOffIcon from '../../../images/icons/microphone-off.svg';
import MicRipple from '../CameraPublisher/components/MicRipple.jsx';

const HardwareSetupCamera = (props) => {
	const state = useContext(StateContext);
	return (
		<>
			{!props.hasVideo || state.streamGenerating ? (
				<>
					<div
						className={`w-full rounded-md bg-darkGrey flex flex-col justify-center items-center relative ${
							props.isInsideGreenRoom ? 'h-48' : 'h-full'
						}`}
					>
						{state.streamGenerating ? (
							<div className={'spinner'}></div>
						) : (
							<div className="flex w-full h-full">
								<div className="m-auto">
									{props.hasAudio ? (
										<MicRipple hasAudio={props.hasAudio} />
									) : (
										<span className="text-mediumGrey text-xs">No camera</span>
									)}
								</div>
								<div className="absolute flex items-center justify-between w-full bottom-0 p-2">
									<div>
										{props.name && (
											<span className="capitalize rounded px-2 py-1/2 bottom-2 left-2 bg-black bg-opacity-50 text-ivory text-sm font-medium">
												{props.name}
											</span>
										)}
									</div>
									<div className="flex items-center space-x-1">
										{!props.hasVideo && (
											<div className="flex justify-center items-center rounded-full bg-opacity-50 bg-black w-6 h-6">
												<CameraOffIcon className="text-ivory w-4 h-4 fill-current" />
											</div>
										)}
										{!props.hasAudio && (
											<div className="flex justify-center items-center rounded-full bg-opacity-50 bg-black w-6 h-6">
												<MicrophoneOffIcon className="text-ivory w-4 h-4 fill-current" />
											</div>
										)}
									</div>
								</div>
							</div>
						)}
					</div>
					{/* <div className={'text-xs text-mediumGrey mt-px'}>
						...
					</div> */}
				</>
			) : (
				<>
					<MediaElement
						mirror={state.currentParticipant.mirrorVideo}
						videoRef={props.videoRef}
						name={props.name}
						mediaStream={props.mediaStream}
					/>
					<div className={'text-xs text-mediumGrey mt-px'}>
						{props.videoSettings?.height}p // {Math.round(props.videoSettings?.frameRate)}fps{' '}
					</div>
				</>
			)}
			{/* <div className="mt-3 mb-4 text-sm text-center text-mediumGrey">
          Your connection speed is{" "}
          <span className={"text-green font-semibold"}>fast ·</span>
        </div> */}
		</>
	);
};

export default HardwareSetupCamera;
